import services from './../services/service'; // Service Class
import validator from './../services/validator'; // Service
import setts from './setts.js'; //varying settings
let service = new services();
let valid = new validator();
export default {
    name: 'DataServer',
    mixins: [setts],
    props: {
        payment_details_data:Object,
    },
    description: 'For all integratable/sharable data calls eg: Businesses, CNpros....',
    data () {
        return {
            // user: {},
            businesses: {},
            business: {},
            cnsurveys: {},
            cnsurvey: {},
            forums: {},
            reviews: {},
            ratings: {},
            adverts: {},
            citisave: {},
            states: {},
            cities: {},
            quote: {},
            businessCategories: {},
            // cndiscount: {},
            cndiscounts:{},
            panelFlag: false,
            addFlag: false,
            editFlag: false,
            deleteFlag: false,
            cnsurveysPanel: false,
            img_url: service.imageURL,
            working_hours: [],
            business_working_hours: {},
            noBusinessSet: false,
            error_here: {},
            error_count: 0,
            //data
            terms_cn_agree:false,
            //messages
            data_processing_message:"",
            //processes
            set_payment_view: false,
            set_payment_details_data:{},
            set_payment_data:{},
            set_payment_object:{},
            set_payment_object_title:"",
            data_server_ready:true, //for calling components
            //uploads
            files_info:[], //muttiple files
            imageForm: "",
            imagesFormArray: [], //multiple files
            max_files_upload: 10,
            //cndiscount_set_duration
            cndiscount_set_duration:14, //default
        }
    },
    components: {},
    methods: {
        //settings
        setPanel(attr,attr2) {
            this.panelFlag = true;
            if(attr == "add"){
                this.editFlag = false;
                this.deleteFlag = false;
                this.addFlag = true;
            }
            if(attr == "edit"){
                this.addFlag = false;
                this.deleteFlag = false;
                this.editFlag = true;
                this.business = attr2;
            }
            if(attr == "delete"){
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = true;
                this.business = attr2;
            }
           if(attr == "view-cnsurveys"){
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = false;
                this.cnsurveysPanel = true;
                //this.getBusinessWorkingHours(attr2);
               
            }

        },

        resets(){
            this.set_payment_view = false;
        },
        
        isActive(index){
            if(index == 1){
                return "active";
            }
        },

        getStates() {
            service.getStates(this).then(function(data) {
                this.states = data.body;
            })
        },

        // getCities(state) {
        //     service.getCities(this, state).then(data => {
        //         this.cities = data.body.data;
        //     })
        // },
 
        // Get cities
        getCities(id) {
            document.getElementById("loader").style.visibility = "visible";
            service.getCities(this, id).then((res) => {
                this.cities = res.body.data;
                document.getElementById("loader").style.visibility = "hidden";
            })
        },
       
       
        //--//settings

        //businesses
        getBusinessCategories() {
            service.getBusinessCategories(this).then(data => {
                if(data.body.status == 200) {
                    this.businessCategories = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                   // toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        addBusiness() {
            this.error_count = 0;
            var credentials = {
                business_user: this.user.user_id,
                business_category: this.business.category,
                business_name: this.business.name,
                business_email: this.business.email,
                business_phone: this.business.phone,
                business_address: this.business.address || " ",
                business_state: 15,//this.business.state,
                business_city: 1,//this.business.city,
                business_description: this.business.description || " ",
                business_website: this.business.website || "nill",
                business_facebook: this.business.facebook || 'https://web.facebook.com/',
                business_twitter: this.business.twitter || 'https://twitter.com/',
                business_instagram: this.business.instagram || 'https://www.instagram.com/',
            }

            let navi = this.$router;
            if(credentials.business_user != null && credentials.business_name != null && credentials.business_category != null && credentials.business_email != null && credentials.business_city != null) {
                //validate
                if(!(valid.validateEmail(credentials.business_email))){
                    this.error_here.email = "Invalid Email";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Email is not valid', 'Warning!');
                }
                if(!(valid.validateName(credentials.business_name))){
                    this.error_here.name = "Name is not valid";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Business Name is not valid', 'Warning!');
                }
                if(!(valid.validatePhoneNumber(credentials.business_phone))){
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Phone Number is not valid', 'Warning!');
                }
                
                if((credentials.business_website != "nill") && (!(valid.validateWebsite(credentials.business_website)))){
                        this.error_count += 1;
                        this.disable_btn = false;
                        toastr.error('Website is not valid', 'Warning!');
                }

                else if(this.error_count == 0){
                    service.addBusiness(this, credentials).then(data => {
                        if(data.body.status == 201) {
                            toastr.success("Business Added!", "Success!");
                            location.reload(true);
                        }else {
                            toastr.error('Sorry, could not add Business', 'Warning!');
                        }
                    }).catch((err) => {
                        if(err) {
                            toastr.error('Sorry, could not process information', 'Warning!');
                        }
                    })
                }else{
                    //console.log("me")
                    }
            }else {
                toastr.error('Complete all fields with *', 'Warning!');
            }
        },

        getBusinesses() {
           let user_id = localStorage.getItem("cityneeds_token_key");
            service.getBusinesses(this, user_id).then(data => {
               if(data.body.status == 200) {
                    this.businesses = data.body.data;
                    let result = data.body.data;
                    let count = 0;
                    result.forEach(function(element) {
                        ++count;
                        if(count == 1){
                            this.business = element; 
                            this.getCities(this.business.business_state); //populate the city
                        }
                    }, this);
                }else{
                    this.noBusinessSet = true;
                }
            }).catch((err) => {
                if(err) {
                    //-->toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getBusiness(business) {
            this.panelFlag = false;
            this.cnsurveysPanel = false;
            service.getBusiness(this, business).then(data => {
                if(data.body.status == 200) {
                    this.business = data.body.data;
                    this.getCities(this.business.business_state); //populate the city
                  }
                   
            }).catch((err) => {
                if(err) {
                  //-----  toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        //
        calcDaysBtwnDays(date_1,date_2){
            // To set two dates to two variables
            var date1 = new Date(date_1);
            var date2 = new Date(date_2);
            
            // To calculate the time difference of two dates
            var difference_in_time = date2.getTime() - date1.getTime();
            
            // To calculate the no. of days between two dates
            var difference_in_days = difference_in_time / (1000 * 3600 * 24);

            return difference_in_days;
        },

        //discounts
        //--addDiscont
        addNewDiscounts() {
            //quick jump  to top here
            document.getElementById('dform_top').scrollIntoView();
            this.data_processing_message = ""; //reset
            // //some settings
            // this.set_payment_object_title = "Make DiscountBazaar Setup Payment";
            // this.set_payment_object_set_callback_url= "business-listings#cndiscounts";
            // this.setPaymentDetails(); //reset to make $updates happen here
            //authen ticate entry
            var payload={
                cndiscount_business_user: this.user.user_id,
                cndiscount_business_category: this.business.category || 0,
                cndiscount_business_name: this.business.name || "",
                cndiscount_business_address: this.business.address || "",
                cndiscount_business_location: this.business.location || "",
                cndiscount_business_map: this.business.map || "",
                cndiscount_business_map_lat: this.business.map_lat || "",
                cndiscount_business_map_lng: this.business.map_lng || "",
                //
                cndiscount_business: this.business.business_id || 0,
                cndiscount_caption: this.cndiscount.cndiscount_caption,
                cndiscount_description: this.cndiscount.cndiscount_description,
                cndiscount_code: this.cndiscount.cndiscount_code,
                cndiscount_link: this.cndiscount.cndiscount_link || "#",
                cndiscount_start_date: this.cndiscount.cndiscount_start_date || "",
                cndiscount_expiry_date: this.cndiscount.cndiscount_expiry_date || "",
                cndiscount_normal_price: Number(this.cndiscount.cndiscount_normal_price) || 0,
                cndiscount_discount_price: Number(this.cndiscount.cndiscount_discount_price) || 0,
            }
            //auths
            let can_post = false;
            //check business
            if((payload.cndiscount_business == 0) && (payload.cndiscount_business_name == '')){
                this.data_processing_message = "Business details is not set";
            }else if((payload.cndiscount_business_category == 0) && (payload.cndiscount_business_category == undefined)){
                this.data_processing_message = "Please select a business category";
            }else{
                //check entries
                if((payload.cndiscount_caption == '') || (payload.cndiscount_code == '')){
                    this.data_processing_message = "Please fill in your discount details";
                }else{
                    //check dates
                    // if((payload.cndiscount_expiry_date).getTime() <= (payload.cndiscount_start_date).getTime()){
                    //     this.data_processing_message = "Please check dates";
                    // }else{
                    //     can_post = true;
                    // }
                    // can_post = true;
                    if((payload.cndiscount_expiry_date == '') || (payload.cndiscount_start_date == '')){
                        this.data_processing_message = "Please check dates";
                        can_post = false;
                    }else{
                        //calcDaysBtwnDays
                        let get_calcDaysBtwnDays = this.calcDaysBtwnDays(payload.cndiscount_start_date,payload.cndiscount_expiry_date);
                        if(Number(get_calcDaysBtwnDays) > Number(this.cndiscount_set_duration)) { 
                            this.data_processing_message = "Please check dates, duration should not be more than "+this.cndiscount_set_duration+" days";
                            can_post = false;
                        }else{
                            //check normal price greater than discount price
                            if((payload.cndiscount_normal_price == 0) && (payload.cndiscount_discount_price == 0)){
                                this.data_processing_message = "Please check prices, discount price and normal price";
                                can_post = false;
                            }else{
                                if(payload.cndiscount_normal_price <= payload.cndiscount_discount_price){
                                    this.data_processing_message = "Please check prices, discount price should be less than normal price";
                                    can_post = false;
                                }else{
                                    can_post = true; //last check assign as true
                                }
                            }
                        }
                    }
                    
                }
            }
            //for updates
            if(this.cndiscount.cndiscount_ref && (this.cndiscount.cndiscount_ref != '')){
                payload.cndiscount_ref = this.cndiscount.cndiscount_ref;
            }
            //
            if(can_post){
                this.setProcessLoading();
                let set_upload_media = false;
                set_upload_media = true;
                service.addNewCNdiscount(this, payload).then(data => {
                    if(data.body.status == 201) {
                        toastr.success("Submitted!", "Success!");
                        //
                        // set_upload_media = true;
                        //send to make payment 
                        this.prepMakePayment(data.body.data.payment_data);
                    }else if(data.body.status == 202) { //existing data but needs payment
                        toastr.success("Updated!", "Success!");
                        //send to make payment 
                        this.prepMakePayment(data.body.data.payment_data);
                    }else if(data.body.status == 200) { //existing data does not need payment
                        toastr.success("Updated!", "Success!");
                        this.onFileChange(data.body.data_id);
                        //send to make business-listing
                        location.reload("/business-listings")
                    }else {
                        toastr.error('Sorry, could not process, please check your entries', 'Warning!');
                        this.data_processing_message = "Sorry, could not process, please check your entries and try again";
                    }
                    if(set_upload_media){
                        if(this.files_info.length > 0){
                            this.onFileChange(data.body.data_id);
                        }
                    }
                    this.stopProcessLoading();
                }).catch((err) => {
                    if(err) {
                      toastr.error('Sorry, could not process information, please check your entries', 'Warning!');
                      this.data_processing_message = "Sorry, could not process, please check your entries and try again";
                    }
                    this.stopProcessLoading();
                })
            }
            
        },
        //prep cndiscount payment
        prepSetCNdiscountPayment(payment_data){
            //some settings
            this.set_payment_object_title = "Make DiscountBazaar Setup Payment";
            this.set_payment_object_set_callback_url= "business-listings#discountbazaar";
            this.setPaymentDetails(); //reset to make $updates happen here
            
            this.setPaymentModeModal(payment_data);
        },

        //general payment settings
        prepMakePayment(payment_data){
            this.set_payment_details_data = payment_data;
            this.set_payment_view = true;
        },

        setPaymentModeModal(payment_data){
            this.data_processing_message = "Processing...";
                        
            this.payment_status = 0; //reset parent var
            this.set_payment_data = payment_data;
            this.set_payment_data.callback_url = payment_data.callback_url;
            
            //this.processCNpayment();
            if((this.set_payment_data.total_amount) && (this.set_payment_data.total_amount > 0)){
                this.paymentModalComponentKey++;
                // $('#paywith').modal();
                let self = this;
                setTimeout(function (){
                    $('#paywith').modal();
                    self.resets();
                }, 10);
            }else{
                this.data_processing_message = "Sorry could not fully submit form, please check your entry, or contact us";
            }     
        },

        setPaymentDetails(){
            this.set_payment_object = {
                payment_detail_type: "general",
                payment_detail_name: this.set_payment_object_title,
                payment_detail_logo: "",
                payment_detail_set_callbackurl: this.set_payment_object_set_callback_url,
            }
        },
        
        setPreps(){
            this.set_payment_details_data = this.payment_details_data; //receive prop data
        },


        //uploads
        setOnFileChange(e,data){
            let files = e.target.files || e.dataTransfer.files;
            if (files.length){
                for(let file of files){
                    //check cap
                    // if(this.files_info.length < this.max_files_upload){
                        //rename
                        let set_name = this.cndiscount.cndiscount_caption.replace(/\s/g, '');
                        file = new File([file], set_name+"-cityneedsng-discounts.jpg");
                        //convert
                        let file_name = file.name
                        let pos = file_name.lastIndexOf(".");
                        let set_file_name = file_name.substr(0, pos < 0 ? file_name.length : pos) + ".jpg"; //override
                        set_file_name = set_file_name.replace(' ', '-'); //change file name
                        // set_file_name = set_file_name.replace(' ', '-'); //remove spaces
                        const new_File = new File([file], set_file_name);
                        this.files_info.push(new_File);
                    // }
                }
            }   
        },

        //
        onFileChange(data) {
            for(let file of this.files_info){
                let formData = new FormData();
                formData.append('photo', file); 
                formData.append('data_id', data);
                formData.append('data_type', "cndiscount_media");   
                service.uploadDataPhoto(this, formData).then(response => {
                }).catch((err) => {});
            }
        },

        getCNSettings(){
            service.getCNSettings(this).then(function(data) {
                for(let setting of data.body.data){
                    if(setting.setting_id == 1){ //cndiscount duration
                        this.cndiscount_set_duration = setting.setting_value; 
                        console.log(this.cndiscount_set_duration);
                    }
                }
            })
        }

    },
    mounted: function(){
       

    },
    created: function(){
    //    this.preset();
        this.getCNSettings();
        this.setPreps();
        this.setPaymentDetails();
        this.getStates();
        this.getBusinessCategories();
        this.getBusinesses();
    //    this.getWorkingHours();
    }
}


// WEBPACK FOOTER //
// ./src/mixins/dataserver.js